import { c as _c } from "react/compiler-runtime";
import { PAYMENT_GATEWAYS_API } from 'modules/profile/payment-gateways/api/payment-gateways-api';
import { PaymentMollieProfileApiInterface } from 'modules/profile/payment-gateways/integrations/mollie/types';
import useUser from 'shared/hooks/use-user';
import { baseFetcher } from 'shared/utils/http-client';
import useSWR from 'swr';
export function useMollieProfiles(shouldFetch) {
  const $ = _c(3);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] !== shouldFetch || $[1] !== user) {
    t0 = () => {
      if (user && shouldFetch) {
        return `${PAYMENT_GATEWAYS_API}/mollie/list-profiles`;
      }
      return null;
    };
    $[0] = shouldFetch;
    $[1] = user;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return useSWR(t0, baseFetcher);
}